import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does NOT reset scroll position on navigation by default.
 * Clicking a footer/nav link changes the route ("navigates") but the
 * viewport stays wherever it was on the previous page — it doesn't "move".
 * Mounting this once inside <BrowserRouter> fixes that globally: every
 * pathname change scrolls the window back to the top.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
